export const mocked = (data: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(data)
    }, 400)
  })
}
